import { useMutation, useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { enqueueSnackbar } from "notistack";
import { zohoApi } from "zohoApi";

dayjs.extend(utc);
dayjs.extend(timezone);

export const useUpdateEventTime = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationKey: ["update-item"],
    mutationFn: async (data) => {
      const { startTimeField, endTimeField, module } = data?.selectedActivity || {};

      let startTime = `${dayjs.utc(data.startTime).format("YYYY-MM-DDTHH:mm")}:00+00:00`;
      if (startTimeField.data_type === "date") {
        startTime = dayjs.utc(startTime).format("YYYY-MM-DD");
      }

      let endTime = `${dayjs.utc(data.endTime).format("YYYY-MM-DDTHH:mm")}:00+00:00`;
      if (endTimeField.data_type === "date") {
        endTime = dayjs.utc(endTime).format("YYYY-MM-DD");
      }

      const startTimeFieldApiName = startTimeField?.api_name;
      const endTimeFieldApiName = endTimeField?.api_name;

      const newData = {};
      newData[startTimeFieldApiName] = startTime;
      newData[endTimeFieldApiName] = endTime;
      newData.id = data?.id;
      newData.moduleApiName = module?.api_name;
      newData.Owner = data.resource;
      const { moduleApiName, ...recordData } = newData;
      const { data: respData } = await zohoApi.record.updateRecord({
        moduleApiName,
        recordData,
      });
      return respData;
    },
    onSuccess: ({ data }) => {
      const codeSUCCESS = data?.[0].code === "SUCCESS";
      if (codeSUCCESS) {
        queryClient.invalidateQueries({ queryKey: ["eventArray"] });
        enqueueSnackbar("Successfull", { variant: "success" });
      }
    },
  });
  return mutate;
};
